const defaultState = {
    tags: {
        title: 'Product Checkout',
        description: "",
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'checkout, boxup'
            }
        }
    }
}

export default function meta (state = defaultState, action) {
    switch(action.type) {
        case "SET_TAGS":
            return {
                ...state,
                tags: action.payload.tags
            }
        case "RESET_TAGS":
            return {
                ...state,
                tags: defaultState.tags
            }
        default:
            return state;
    }
}